$(document).on('turbolinks:load', function(){
    $('.show-row-data').on('click', function(event) {
       if ($(event.target).closest('a').length === 0) {
           window.location.href = $(this).data('link');
       }
    })
})
